export default __webpack_public_path__ + "static/media/new-map-3.e6d67446.png";